<template>
  <div class="contents update">
    <h2>社員マスタ　更新</h2>
    <div class="container">
      <template v-if="isLoading">
        <template v-if="!isError">
          <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
        </template>
      </template>
      <template v-else-if="!isError">
        <div class="maininfo">
          <div v-show="isEdit">
            <div class="tabs">
              <scroll-tabs>
                <ul>
                  <li :class="{ active: tab === 'update-basic' }">
                    <a @click="tab = 'update-basic'">基本情報</a>
                  </li>
                  <li :class="{ active: tab === 'upload' }">
                    <a @click="tab = 'upload'">添付ファイル</a>
                  </li>
                </ul>
              </scroll-tabs>
            </div>
          </div>
          <!-- /tabs -->

          <div class="tab-container">
            <component :is="currentTab" :form="form" :tab="tab" :options="options" :isEdit="isEdit"/>
          </div>
        </div>
        <!-- /maininfo -->
      </template>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <template v-if="isEdit">
          <router-link :to="{
            name: RouterConst.SYAIN_DETAIL
          }">詳細画面に戻る
          </router-link>
        </template>
        <template v-else>
          <router-link :to="{
            name: RouterConst.SYAIN_LIST 
          }">検索画面に戻る
          </router-link>
        </template>
      </p>
      <p class="btn-temporary-save" v-show="isEdit">
        <button type="button" @click="save" :disabled="isLoading || isUpdateing">
          <template v-if="isUpdateing">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>保存中…
          </template>
          <template v-else>
            <i class="fa-solid fa-floppy-disk"></i>保存
          </template>
        </button>
      </p>
      <p class="btn-temporary-save" v-show="!isEdit">
        <button type="button" @click="save" :disabled="isLoading || isCreating">
          <template v-if="isCreating">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i>登録中…
          </template>
          <template v-else>
            <i class="fa-solid fa-floppy-disk"></i>登録
          </template>
        </button>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useInit } from "@/composable/syain/update/init";
import { useUpdate } from "@/composable/syain/update/update";
import { useCreate } from "@/composable/syain/update/create";
import { useTab } from "@/composable/common/tab";
import { useForm } from "@/composable/form/form";
import PartsUpdateBasic from "@/components/syain/parts/UpdateBasic.vue";
import PartsUpload from "@/components/syain/parts/Upload.vue";
import { useRouter } from 'vue-router';
import { RouterConst } from "@/const/Router";
import OptionConst from '@/const/SyainMaster/Option';

export default defineComponent({
  setup() {
    // 初期化処理
    const { form, isError, isLoading, isEdit, kinmuStatus, staffCode, options } = useInit();

    // タブの切替
    const { tab, currentTab } = useTab("update-basic");

    // 更新処理
    const { isUpdateing, update } = useUpdate();

    // 登録処理
    const { isCreating, create } = useCreate();

    const router = useRouter();

    // エラー取得
    const { getError } = useForm();

    // Update処理
    const save = () => {
      if (isEdit.value) {
        // 更新処理
        update(form).then((res) => {
          if(res){
            router.push({ name: RouterConst.SYAIN_DETAIL, params: { id: res } });
          }
        });
      } else {
        // 登録処理
        create(form).then((res) => {
          if(res){
            router.push({ name: RouterConst.SYAIN_DETAIL, params: { id: res } });
          }
        });
      }
    };

    return {
      form,
      isError,
      isLoading,
      tab,
      currentTab,
      getError,
      isUpdateing,
      isCreating,
      save,
      isEdit,
      RouterConst,
      kinmuStatus,
      staffCode,
      options,
      router,
      "kinmuStatusType": OptionConst.KINMU_STATUS_TYPE,
    };
  },
  components: {
    "parts-update-basic": PartsUpdateBasic,
    "parts-upload": PartsUpload,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>
